define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-gallery/canned/contentCannedEmptyTableView.tmpl");


    var ContentCannedEmptyTableView = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedEmptyTableView = Marionette.ItemView.extend({
            template: template,
            className: "empty-tbl"
        });
    });

    return ContentCannedEmptyTableView;
});